import { Button } from '../ui/button';

export interface UnsavedBarProps {
  visible: boolean;
  /** Replaces "You have unsaved changes", e.g. "1 field needs fixing before you can save". */
  message?: string;
  onDiscard: () => void;
  onSave: () => void;
  saving?: boolean;
  /** True while a field is invalid: Save stays disabled, per Figma A16.6. */
  saveDisabled?: boolean;
}

/** The floating dark "You have unsaved changes" bar (Figma A16.1 / A16.6). */
export function UnsavedBar({
  visible,
  message = 'You have unsaved changes',
  onDiscard,
  onSave,
  saving = false,
  saveDisabled = false,
}: UnsavedBarProps) {
  if (!visible) return null;
  return (
    <div className="pointer-events-none fixed inset-x-(--mbm-space-4) bottom-(--mbm-space-6) z-(--mbm-z-raised) flex justify-center">
      <div
        role="status"
        className="pointer-events-auto flex w-full max-w-(--mbm-layout-unsaved-bar-width) items-center justify-between gap-(--mbm-space-4) rounded-full bg-action-primary py-(--mbm-space-2) pl-(--mbm-space-6) pr-(--mbm-space-2) text-text-on-dark shadow-(--mbm-shadow-lg)"
      >
        <span className="text-label-large">{message}</span>
        <div className="flex items-center gap-(--mbm-space-2)">
          <button
            type="button"
            onClick={onDiscard}
            disabled={saving}
            className="h-(--mbm-size-button-compact) rounded-full px-(--mbm-space-4) text-label-large hover:opacity-(--mbm-opacity-pressed) focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)"
          >
            Discard
          </button>
          <Button variant="secondary" size="compact" onClick={onSave} loading={saving} disabled={saveDisabled}>
            Save changes
          </Button>
        </div>
      </div>
    </div>
  );
}
